
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class SectionDocumentMetaData extends Vue
{
    @Prop()
    created_at!: Date;
    @Prop()
    created_by!: string;

    @Prop({ required: false })
    updated_at?: Date | null;
    @Prop({ required: false })
    updated_by?: string | null;
}
